<ul class="nav nav-tabs">
    <li *ngFor="let tab of tabs" class="nav-item">
        <a
            *ngIf="!tab.hidden"
            class="nav-link"
            [ngClass]="{ active: tab.active, 'text-danger': tab.alert }"
            (click)="selectTab(tab)">
            {{ tab.title }}
        </a>
    </li>
</ul>

<div class="mt-2">
    <ng-content></ng-content>
</div>
